import z from 'zod';
import { userIdValue } from '../../subscription/value-objects/ids';
import { favoriteIdValue, favoriteTargetTypeValue, } from '../value-objects/ids';
const nonEmptyDocumentId = z.string().trim().min(1);
export const favoriteSchema = z.object({
    createdAt: z.date(),
    id: favoriteIdValue,
    targetDocumentId: nonEmptyDocumentId,
    targetType: favoriteTargetTypeValue,
    themeDocumentId: nonEmptyDocumentId,
    userId: userIdValue,
});
export const parseFavorite = (value) => favoriteSchema.parse(value);
export const isFavorite = (value) => favoriteSchema.safeParse(value).success;
//# sourceMappingURL=favorite.js.map